exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h5-wrap .q-edit-content .q-select-item .vh-checkbox__label {\n  padding-left: 10px;\n}\n.h5-wrap.isReplayH5 .vh-radio__input.is-disabled + span.vh-radio__label,\n.h5-wrap.isReplayH5 .vh-checkbox__input.is-disabled + span.vh-checkbox__label {\n  color: #c2c2c2;\n}\n.h5-wrap.isReplayH5 .vh-input.is-disabled .vh-input__inner {\n  background-color: #fff;\n  color: #c2c2c2;\n}\n", ""]);

// exports
